import React, { useState, useEffect, useRef } from "react";
import "./index.scss";
import { Box, Grid } from "@mui/material";
import CustomButtonComponent from "../../../../core/custom-button";
import { getFaqFormConfig, HeaderConfig } from "./config";
import FormGenerator from "../../../../core/form-generator";
import { handleFormValidation } from "../../../../utils";
import { HTTP_METHODS, invokeApi } from "../../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../../utils/endpoints";
import { toast } from "react-toastify";
import CustomTable from "../../../../core/custom-table";
import DeleteModal from "../../../../components/delete-modal";
import ReactQuill from "react-quill";
import JoditEditor from "jodit-react";
const FaqAdmin = () => {
  const [isEdit, setIsEdit] = useState({
    isOpen: true,
    data: {},
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isDelete, setIsDelete] = useState({ isOpen: false, data: {} });
  const [filters, setFilters] = useState({
    page: 1,
    sortBy: "-createdAt",
    limit: 4,
  });
  const [formData, setFormData] = useState({});
  const [data, setData] = useState({});
  const [errors, setErrors] = useState({});
  const editor = useRef(null);

  const resetHandler = () => {
    setIsEdit({
      isOpen: true,
      data: {},
    });
    setFormData({});
    loadData(filters);
  };
  const submitHandler = () => {
    const isValid = handleFormValidation(
      getFaqFormConfig(),
      setErrors,
      formData
    );
    if (isValid) {
      const payload = {
        question: formData?.question,
        answer: formData?.answer,
      };
      if (isEdit?.data?.id) {
        const { id } = isEdit?.data;
        invokeApi(
          HTTP_METHODS.PUT,
          `${HOSTNAME}${REST_URLS.FAQ}/${id}`,
          payload
        )
          .then((res) => {
            if (res.message) {
              toast.error(res.message);
            } else {
              toast.success("Updated Successfully");
              resetHandler();
            }
          })
          .catch((err) => console.error(err));
      } else {
        invokeApi(HTTP_METHODS.POST, `${HOSTNAME}${REST_URLS.FAQ}`, payload)
          .then((res) => {
            if (res.message) {
              toast.error(res.message);
            } else {
              toast.success("Created Successfully");
              resetHandler();
            }
          })
          .catch((err) => console.error(err));
      }
    }
  };
  const decodeHtml = (html) => {
    const parser = new DOMParser();
    return parser.parseFromString(html, "text/html").documentElement
      .textContent;
  };
  const ClickHandler = (data, type) => {
    switch (type) {
      case "EDIT":
        setIsEdit({
          isOpen: true,
          data: data,
        });
        const decodedContent = decodeHtml(data?.answer);
        setFormData({
          question: data?.question,
          answer: decodedContent,
        });
        break;
      case "DELETE":
        setIsDelete({
          isOpen: true,
          data: data,
        });
      default:
        break;
    }
  };
  const loadData = (filter) => {
    setIsLoading(true);
    invokeApi(HTTP_METHODS.GET, `${HOSTNAME}${REST_URLS.FAQ}`, null, filter)
      .then((res) => {
        if (res.message) {
          toast.error(res.message);
        } else {
          const result = res?.results?.map((ele, index) => ({
            ...ele,
            siNo: index + 1,
          }));
          setData({ ...res, results: result });
        }
        setIsLoading(false);
      })
      .catch((err) => console.error(err));
  };
  const deleteHandler = () => {
    if (isDelete?.data?.id) {
      const { id } = isDelete?.data;
      invokeApi(HTTP_METHODS.DELETE, `${HOSTNAME}${REST_URLS.FAQ}/${id}`)
        .then((res) => {
          if (res.message) {
            toast.error(res.message);
          } else {
            toast.success("Deleted Successfully");
            setIsDelete({ isOpen: false, data: {} });
            resetHandler();
          }
        })
        .catch((err) => console.error(err));
    }
  };

  useEffect(() => {
    loadData(filters);
  }, []);
  return (
    <div className="page-body">
      <div>
        <p className="tab-name">Literature</p>
        <p className="section-name">FAQ</p>
      </div>
      <Grid container>
        <Grid md={4}>
          <div
            className="form-con"
            style={{
              marginLeft: "0px",
              marginRight: "0px",
              width: "100%",
              marginBottom: "1rem",
            }}
          >
            <p className="primary-text p-margin-0">FAQ</p>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-around",
                m: 3,
                ml: 0,
              }}
            >
              <CustomButtonComponent
                variant={isEdit?.isOpen ? "outlined" : "contained"}
                fullWidth
                onClick={() => {
                  if (isEdit?.isOpen) {
                    setIsEdit({
                      isOpen: false,
                      data: {},
                    });
                    setFormData({});
                  }
                }}
                sx={{ mr: 2 }}
              >
                Create New
              </CustomButtonComponent>
              <CustomButtonComponent
                variant={isEdit?.isOpen ? "contained" : "outlined"}
                fullWidth
                onClick={() => {
                  setIsEdit({
                    isOpen: true,
                    data: {},
                  });
                  setFormData({});
                }}
                sx={{ ml: 2 }}
              >
                View/ Modify
              </CustomButtonComponent>
            </Box>
          </div>
          <CustomTable
            header={HeaderConfig}
            data={data.results || []}
            pageCount={data.totalPages}
            filters={filters}
            onClick={ClickHandler}
            onChange={(page) => {
              setFilters({
                ...filters,
                page,
              });
              loadData({
                ...filters,
                page,
              });
            }}
            isLoading={isLoading}
          />
        </Grid>
        <Grid md={8}>
          <div className="form-con">
            <FormGenerator
              config={getFaqFormConfig()}
              formData={formData}
              setFormData={setFormData}
              errors={errors}
              setErrors={setErrors}
              fieldGridSize={3}
            />
            <p>Answer *</p>
            {/* <ReactQuill
              theme="snow"
              className="text-editor-con"
              value={formData?.answer}
              onChange={(content) =>
                setFormData((prevVal) => ({
                  ...prevVal,
                  answer: content,
                }))
              }
            /> */}
            <JoditEditor
              ref={editor}
              value={formData?.answer || ""}
              config={{
                readonly: false,
                toolbarSticky: false,
                height: 400,
                autofocus: false,
                buttons: [
                  "bold",
                  "italic",
                  "underline",
                  // "|",
                  // "ul",
                  // "ol",
                  // "|",
                  "table",
                  // "image",
                  // "video",
                  // "|",
                  // "source",
                  "undo",
                  "redo",
                ],
              }}
              onBlur={(newContent) => {
                setFormData((prevVal) => ({
                  ...prevVal,
                  answer: newContent,
                }));
              }}
            />
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                mt: "4rem",
                mb: 4,
              }}
            >
              <CustomButtonComponent
                variant="contained"
                sx={{ width: "200px" }}
                onClick={submitHandler}
              >
                Submit
              </CustomButtonComponent>
            </Box>
          </div>
        </Grid>
      </Grid>
      {isDelete?.isOpen && (
        <DeleteModal
          deleteHandler={deleteHandler}
          onClose={() => {
            setIsDelete({ isOpen: false, data: {} });
          }}
        />
      )}
    </div>
  );
};

export default FaqAdmin;
